import { FormInfo, ScoredForms } from './FormInfo.js';
import WriteDB from '../../API/WriteDB.js'

const writeDB = new WriteDB();
export default class FormHelp{
    /**
     * Sets the component of the form that is being used
     * @param {Component} comp 
     */
    setComponent(comp){
        this.component = comp;
    }

    /**
     * Sets the name of the form that is being used
     * @param {String} name 
     */
    setName(name){
        this.name = name;
    }

    /**
     * Sets the number of columns for the form being used
     * @param {int} length
     */
    setColumnLength(length){
        this.columnLength = length;
    }

    /**
     * Creates a state list for the component. Changes based off of which form is being used
     * @param {int} length Determines how long to make the list
     * @returns a list that represents the state of the component
     */
    getList(length){
        var list = {};
        var i = 0;
        if(this.name === FormInfo.Medication.name){
            for(i = 0;i < length;i++){
                list[this.name + '_' + i + '_taken'] = 'No';
                list[this.name + '_' + i + '_side'] = 'No';
                list[this.name + '_' + i + '_helpful'] = 'No';
                list[this.name + '_' + i + '_c'] = '';
            }
        }else if(this.name === FormInfo.Development.name){
            for(i = 0;i < length;i++){
                list[this.name + '_' + i] = '';
                list[this.name + '_' + i + '_c'] = '';
            }
        }else if(this.name === FormInfo.Trauma.name){
            for(i = 0;i < length;i++){
                list[this.name + '_' + i + '_adult'] = 'No';
                list[this.name + '_' + i + '_child'] = 'No';
            }
        }else if(this.name === FormInfo.Family.name){
            for(i = 0;i < length;i++){
                list[this.name + '_' + i + '_father'] = 'No';
                list[this.name + '_' + i + '_mother'] = 'No';
                list[this.name + '_' + i + '_brother'] = 'No';
                list[this.name + '_' + i + '_sister'] = 'No';
                list[this.name + '_' + i + '_grandmother'] = 'No';
                list[this.name + '_' + i + '_grandfather'] = 'No';
                list[this.name + '_' + i + '_son'] = 'No';
                list[this.name + '_' + i + '_daughter'] = 'No';
                list[this.name + '_' + i + '_self'] = 'No';
            }
        }else{
            for(i = 0;i < length;i++){
                list[this.name + '_' + i] = '';
            }
        }
        
        if(this.name === FormInfo.Prime.name){
            list['show_prime'] = false;
            list['show_header'] = true;
        }

        list['submitText'] = 'Submit'
        list['showAlert'] = false;
        if(window.innerWidth <= 400){
            list['showCollapsed'] = true;
        }else{
            list['showCollapsed'] = false;
        }
        return list;
    }

    /**
     * Handles when the user clicks the screen inside one of the boxes surrounding a radio button 
     * or checkbox.
     * Also handles if the Prime form should be shown
     * @param {Object} e event object that is used to determine what box the user clicked on
     */
    handleClick = e =>{
        if(e.target.name === FormInfo.Prime.name + '_yes'){
            this.component.setState({show_header:false})
            this.component.setState({show_prime:true})
        }else if(e.target.name === FormInfo.Prime.name + '_no'){
            this.component.props.message({[FormInfo.Prime.name]:0});
            writeDB.writeCompletedForm(FormInfo.Prime.name);
        }

        if(e.target.id.slice(-2,-1) === 'r'){
            var key = e.target.id.slice(0,-3)
            if(this.name === FormInfo.Medication.name){
                if(e.target.id.slice(-1) === '1'){
                    key += '_taken'
                }else if(e.target.id.slice(-1) === '2'){
                    key += '_helpful'
                }else{
                    key += '_side'
                }
            }

            if(this.name === FormInfo.Trauma.name){
                if(e.target.id.slice(-1) === '1'){
                    key += '_adult';
                }else{
                    key += '_child'
                }
            }

            if(this.name === FormInfo.Family.name){
                if(e.target.id.slice(-1) === '1'){
                    key += '_father'
                }else if(e.target.id.slice(-1) === '2'){
                    key += '_mother'
                }else if(e.target.id.slice(-1) === '3'){
                    key += '_brother'
                }else if(e.target.id.slice(-1) === '4'){
                    key += '_sister'
                }else if(e.target.id.slice(-1) === '5'){
                    key += '_grandfather'
                }else if(e.target.id.slice(-1) === '6'){
                    key += '_grandmother'
                }else if(e.target.id.slice(-1) === '7'){
                    key += '_son'
                }else if(e.target.id.slice(-1) === '8'){
                    key += '_daughter'
                }else{
                    key += '_self'
                }
            }
            if(document.getElementById(e.target.id.slice(0,-2) + e.target.id.slice(-1)) !== null){
                document.getElementById(e.target.id.slice(0,-2) + e.target.id.slice(-1)).checked = true;
                this.component.setState({[key] : document.getElementById(e.target.id.slice(0,-2) + e.target.id.slice(-1)).value}); 
                
            }else if(this.name === FormInfo.Family.name || this.name === FormInfo.Trauma.name || this.name === FormInfo.Medication.name){
                if(document.getElementById(key).checked){
                    document.getElementById(key).checked = false;
                    this.component.setState({[key]:'No'}); 
                }else{
                    document.getElementById(key).checked = true;
                    this.component.setState({[key]:'Yes'}); 
                }         
            }
        }
    }

    /**
     * Highlights a unanswered row temporarily and then removes the highlight
     * @param {String} key the name of row that is unanswered
     */
    showError(key){
        var i = 0;
        if(this.name === FormInfo.ASRM.name){
            document.getElementById(key).scrollIntoView({behavior:'smooth'});
            for(i = 0;i < 5;i++){
                document.getElementById(key + '_p' + i).classList.add('highlight');
            }

            for(i = 0;i < 5;i++){
                document.getElementById(key + '_r' + i).classList.add('highlight');
            }

            this.timeout = setTimeout(() =>{
                for(i = 0;i < 5;i++){
                    document.getElementById(key + '_p' + i).classList.remove('highlight');
                }
    
                for(i = 0;i < 5;i++){
                    document.getElementById(key + '_r' + i).classList.remove('highlight');
                }
            },2000);

        }else{
            document.getElementById(key + '_p').scrollIntoView({behavior:'smooth'})
            document.getElementById(key + '_p').classList.add('highlight');
            for(i = 1;i <= this.columnLength;i++){
                if(document.getElementById(key + '_r' + i) === null){
                    break;
                }else{
                    document.getElementById(key + '_r' + i).classList.add('highlight');
                }
            }

            for(i = 1;i <= this.columnLength;i++){
                if(document.getElementById(key + '_p' + i) === null){
                    break;
                }else{
                    document.getElementById(key + '_p' + i).classList.add('highlight');
                }
            }

            this.timeout = setTimeout(() =>{
                document.getElementById(key + '_p').classList.remove('highlight');
                for(i = 1;i <= this.columnLength;i++){
                    if(document.getElementById(key + '_r' + i) === null){
                        break;  
                    }else{
                        document.getElementById(key + '_r' + i).classList.remove('highlight');
                    }
                }

                for(i = 1;i <= this.columnLength;i++){
                    if(document.getElementById(key + '_p' + i) === null){
                        break;
                    }else{
                        document.getElementById(key + '_p' + i).classList.remove('highlight');
                    }
                }
            },2000);
        }
    }   

    /**
     * Clears out the timeout that is used in showError()
     */
    clearTime(){
        clearTimeout(this.timeout);
    }

    /**
     * Handles when the user submits a form
     * @param {Object} event 
     */
    handleSubmit = async(event) =>{
        event.preventDefault();
        this.component.setState({submitText:'Submitting'});
        if(this.name === FormInfo.Family.name || this.name === FormInfo.Trauma.name || 
            this.name === FormInfo.Medication.name){
            if(this.name === FormInfo.Family.name || this.name === FormInfo.Medication.name){
                await writeDB.sendData(this.name,this.component.getData())
            }else{
                await writeDB.sendData(this.name,this.component.state)
            }
            this.component.props.message({[this.name]:'done'});
        }else{
            var error = false;
            var total = 0;
            for(const key in this.component.state){
                if(this.component.state[key] === '' && key.slice(-1) !== 'c'){
                    error = true;
                    this.showError(key);
                    this.component.setState({submitText:'Submit'});
                    break;
                }

                if(Number.isInteger(parseInt(this.component.state[key],10)) && key !== 'submitText'){
                    total += parseInt(this.component.state[key],10);
                }
            }

            if(!error){
                var response;
                if(ScoredForms.includes(this.name)){
                    response = await writeDB.sendData(this.name,this.component.getData())
                }else{
                    response = await writeDB.sendData(this.name,this.component.state)
                }

                if(response){
                    this.component.props.message({[this.name]:total});
                }else{
                    this.component.setState({showAlert:true})
                }
            }
        }
    }
}